import * as React from 'react'

import('./OddsRowStyles.scss')   


interface OddsRowProps {
  oddsValue1: any
  oddsValue2: any
  oddsValue3: any
  homeOrAway: any
  betstop: boolean
  matchId: number
  clickedOdds: ( oddsValue: any ) => void
  winnerDetermined: boolean
}

class OddsRow extends React.Component<OddsRowProps, any> {
  constructor ( props: OddsRowProps ) {
    super( props )

    this.createOddObjectAndTriggerAction = this.createOddObjectAndTriggerAction.bind( this )

    this.state = {
      odds: {
        [1]: {
          current: props.oddsValue1.team[ props.homeOrAway ],
          last: props.oddsValue1.team[ props.homeOrAway ],
        },
        [2]: {
          current: props.oddsValue2.team[ props.homeOrAway ],
          last: props.oddsValue2.team[ props.homeOrAway ],
        },
        [3]: {
          current: props.oddsValue3.team[ props.homeOrAway ],
          last: props.oddsValue3.team[ props.homeOrAway ],
        }
      },
      clickTimeouts: []
    }
  }

  createOddObjectAndTriggerAction ( event: any, oddsObject: any ) {
    if (this.props.betstop || oddsObject.team['home'].odds === '' || oddsObject.team['away'].odds === '' ) {
      return
    }
    
    const {matchId, homeOrAway} = this.props
    const specifiers = oddsObject.specifiers
    const team = oddsObject.team[homeOrAway]
    const outcomeId = team.id
    const oddsValue = team.odds
    const oddsReference = `${matchId}-${specifiers}-${outcomeId}`
    const marketId = oddsObject.id
    const unifiedEventId = 'vti:match:' + matchId // TODO: replace the string with unifiedEventId
    // TODO: this is really specific and could a a function maybe in the odds reducer
    const oddsInfoObject = {
      event_id: matchId,
      unified_event_id: unifiedEventId,
      market_specifier: specifiers,
      market_id: marketId,
      odd_value: oddsValue,
      outcome_id: parseInt(outcomeId)
    }

    this.handleClickedStatus( event.target, oddsReference )

    this.props.clickedOdds({ bets: [oddsInfoObject]} )
  }

  handleClickedStatus ( element: any, oddId: string ) {
    const { clickTimeouts } = this.state
    
    let button = element
    
    // check if the clicked element contains 'odd-button'. if not it can only be a child container. 
    if( !element.classList.contains( 'odd-button' ) ) {
      button = element.parentNode
    }

    button.classList.add('clicked')
    
    // save the new timeout to the clickedTimeouts state to change the clicke state back to unclicked
    this.saveClickedOddTimeout([
      // find and get a clickedTimeout element for the clicked odd if available and remove the timeout
      ...this.removeClickedOddTimeout(clickTimeouts.find((timeout: any) => timeout.oddId === oddId), clickTimeouts),
      // create the new timeout
      ...this.addClickedOddTimeout(clickTimeouts, oddId, this.createCallbackTimeout(button, oddId))
    ])
    
  }

  createCallbackTimeout(button: any, oddId: string) {  

    const callbackTimeout = () => {
      const { clickTimeouts } = this.state
      const clickTimeout = clickTimeouts.find(e => e.oddId === oddId)
      const tmpClickTimeouts = this.removeClickedOddTimeout(clickTimeout, clickTimeouts)
      
      button.classList.remove('clicked')
      
      this.saveClickedOddTimeout(tmpClickTimeouts)
    }

    return setTimeout(callbackTimeout, 250)
  }

  removeClickedOddTimeout ( clickTimeout: any, clickTimeouts: any ) {
    if( !clickTimeout ) {
      return clickTimeouts
    }
    
    const tmpTimeouts = [ ...clickTimeouts ]
    
    clearTimeout(clickTimeout.id)
    tmpTimeouts.splice(clickTimeout.index)
    
    return tmpTimeouts
  }

  // todo: the third argument is a "Timer", perhaps type "NodeJS.Timer" matches ?
  addClickedOddTimeout (clickTimeouts: any, oddId: any, timeoutId: any) {
    const tmpTimeouts = [...clickTimeouts]
    
    tmpTimeouts.push({ id: timeoutId, oddId: oddId, index: (tmpTimeouts.length) })

    return tmpTimeouts
  }

  saveClickedOddTimeout(clickTimeouts: any) {
    this.setState({
      clickTimeouts: [
        ...clickTimeouts
      ]
    })
  }

  render () {
    const { 
      homeOrAway,
      oddsValue1,
      oddsValue2,
      oddsValue3,
      betstop,
      winnerDetermined,
    } = this.props;
    return (
      <div className="oddsWrapperGrid">
        <div className="sr-grid sr-with-spacer sr-row-align-center oddsRow">
          <div className="sr-cell sr-xs-1-3 sr-cell-align-center">
            <div className="sr-spacer">
              <div  onClick={ ( event ) => { this.createOddObjectAndTriggerAction( event, oddsValue1 ) } }
                    className={`odd-button sr-content sr-align-center oddsMarketSet-value
                                ${isBetstop(betstop, winnerDetermined)}
                                ${isOddEmpty(oddsValue1.team[homeOrAway].odds, winnerDetermined)}
                                ${isHigherLower(oddsValue1.team[homeOrAway].trend)}`}>
                {!winnerDetermined 
                  ? <span>{oddsValue1.team[homeOrAway].odds}</span> 
                  : null}
              </div>
            </div>
          </div>
          <div className="sr-cell sr-xs-1-3 sr-cell-align-center">
            <div className="sr-spacer">
              <div  onClick={ ( event ) => { this.createOddObjectAndTriggerAction( event, oddsValue2 ) } }
                    className={`odd-button sr-content sr-align-center oddsMarketNexGame-value
                                ${isBetstop(betstop, winnerDetermined)}
                                ${isOddEmpty(oddsValue2.team[homeOrAway].odds, winnerDetermined)}
                                ${isHigherLower(oddsValue2.team[homeOrAway].trend)}`}>
                {!winnerDetermined 
                  ? <span>{oddsValue2.team[homeOrAway].odds}</span> 
                  : null}
              </div>
            </div>
          </div>
          <div className="sr-cell sr-xs-1-3 sr-cell-align-center">
            <div className="sr-spacer">
              <div  onClick={ ( event ) => { this.createOddObjectAndTriggerAction( event, oddsValue3 ) } }
                    className={`odd-button sr-content sr-align-center oddsMarketNexPoint-value
                                ${isBetstop(betstop, winnerDetermined)}
                                ${isOddEmpty(oddsValue3.team[homeOrAway].odds, winnerDetermined)}
                                ${isHigherLower(oddsValue3.team[homeOrAway].trend)}`}>
                {!winnerDetermined 
                  ? <span>{oddsValue3.team[homeOrAway].odds}</span> 
                  : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const isOddEmpty = (value: string, winnerDetermined: boolean) => {
  if(value !== '' && !winnerDetermined) {
    return ''
  }

  return 'close'
}

const isBetstop = (value: boolean, winnerDetermined: boolean) => {
  return (
    value || winnerDetermined
      ? 'betstop'
      : ''
  )
}

const isHigherLower = (offset: number) => {
  let className: string = ''

  if( offset < 0 ) {
    className = 'higher'
  } else if( offset > 0 ) {
    className = 'lower'
  }

  return className
}

export default OddsRow
